import angular from 'angular';

class MultiRegistrySelectController {
  /* @ngInject */
  constructor($scope) {
    this.$scope = $scope;
  }

  $onInit() {
    // Initialize the component
  }

  $onChanges(changes) {
    // Handle changes to bindings
    if (changes.value) {
      this.value = changes.value.currentValue || [];
    }
    if (changes.options) {
      this.options = changes.options.currentValue || [];
    }
  }
}

export default MultiRegistrySelectController;
angular.module('portainer.app').controller('multiRegistrySelectController', MultiRegistrySelectController);
